<template>
    <component :is="layout" />

    <notifications
        class="min-md:mr-5 min-md:mt-5 z-110 cursor-pointer"
        :max="3"
        width="90%"
        :position="positionNotification"
    />
</template>

<script setup>
import {
    computed, markRaw,
    onMounted, onUnmounted, provide, ref, watch,
} from 'vue'
import { Notifications, useNotification } from '@kyvg/vue3-notification'
import { useRoute } from 'vue-router'

import { useDefaultStore } from '@/store/defaultStore'

import MainLayout from '@/layouts/MainLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

import { viewPorts } from '@/constants/viewPorts'

const route = useRoute()
const { notify } = useNotification()
const defaultStore = useDefaultStore()

let resizeObserver = null
const currentViewSize = ref(0)

const layout = computed(() => {
    const layout = `${route.meta.layout || 'empty'}-layout`

    const lookup = {
        'main-layout': MainLayout,
        'empty-layout': EmptyLayout,
    }

    return lookup.hasOwnProperty(layout) ? markRaw(lookup[layout]) : null
})

const isMbView = computed(() => viewPorts.mb >= currentViewSize.value)

const positionNotification = computed(() => (isMbView.value ? 'bottom center' : 'top right'))

provide('currentViewSize', currentViewSize)

function initResizeObserver() {
    resizeObserver = new ResizeObserver(() => {
        const name = Object.keys(viewPorts).find((name) => viewPorts[name] >= window.innerWidth)

        currentViewSize.value = viewPorts[name]
    })

    resizeObserver.observe(document.body)
}

onMounted(() => {
    initResizeObserver()
})

watch(() => defaultStore.message, (text) => {
    if (text) {
        notify({ type: defaultStore.type, text, duration: defaultStore.duration })
        defaultStore.clearMessage()
    }
})

onUnmounted(() => {
    resizeObserver.disconnect(document.body)
})
</script>
